import {Component, Input} from '@angular/core';
import {ITableColumn} from 'app/main/shared/shared/table/table-column';
import {ITableCellItem} from "../../../../../shared/shared/table/table-cell";
import {IDocumentDto} from "../../../dto/document-listing.dto";

@Component({
    selector: 'app-owner-column',
    templateUrl: './owner-column.component.html',
    styleUrl: './owner-column.component.scss'
})
export class OwnerColumnComponent implements ITableCellItem {
    @Input() dataItem: IDocumentDto;
    columnOptions: ITableColumn;

}
